import { render, staticRenderFns } from "./ConfirmationDialog2.vue?vue&type=template&id=183d155e"
import script from "./ConfirmationDialog2.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports